import {h, Fragment} from "preact"
import { useAppStateSelector, useSelectedFiltersCount, pick } from "@nosto/preact"
import { sortOptions } from "../config"
import Icon from "./elements/Icon"
import { toggleButtonId } from "./Sidebar"

function ToggleMobileSidebarButton({ selectedFiltersCount, className }) {
    return (
        <label
            for={toggleButtonId}
            className={`ns-filters-toggle ns-filters ns-d-inline-flex ns-text-align-center ns-justify-content-between ns-align-items-center ${className}`}
        >
            <span>Filter & Sort</span>
            <span style="height: 24px;">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <g clip-path="url(#clip0_2535_11061)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M7.12469 6.59997C6.85825 7.63507 5.91864 8.39994 4.80034 8.39994C3.47487 8.39994 2.40039 7.32545 2.40039 5.99999C2.40039 4.67452 3.47487 3.60004 4.80034 3.60004C5.91864 3.60004 6.85825 4.3649 7.12469 5.4H23.4003C23.7316 5.4 24.0003 5.66859 24.0003 5.99999C24.0003 6.33138 23.7316 6.59997 23.4003 6.59997H7.12469ZM6.00031 5.99999C6.00031 6.66278 5.46301 7.19996 4.80034 7.19996C4.13767 7.19996 3.60037 6.66266 3.60037 5.99999C3.60037 5.33732 4.13767 4.80001 4.80034 4.80001C5.46301 4.80001 6.00031 5.33719 6.00031 5.99999Z" fill="black"/>
                        <path d="M0.599987 6.6H2.47555C2.42616 6.40828 2.39995 6.20718 2.39995 6.00001C2.39995 5.79284 2.42616 5.59175 2.47555 5.40002H0.599987C0.268589 5.40002 0 5.66861 0 6.00001C0 6.33141 0.268589 6.6 0.599987 6.6Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.3243 17.4C14.0579 16.3649 13.1182 15.6 12 15.6C10.8818 15.6 9.94196 16.3649 9.67565 17.4H0.599987C0.268589 17.4 0 17.6687 0 18C0 18.3313 0.268589 18.6 0.599987 18.6H9.67552C9.94196 19.6351 10.8817 20.3999 11.9999 20.3999C13.118 20.3999 14.0579 19.6351 14.3242 18.6H23.3998C23.731 18.6 23.9997 18.3313 23.9997 18C23.9997 17.6687 23.731 17.4 23.3998 17.4H14.3243ZM12 19.2C12.6628 19.2 13.2 18.6628 13.2 18C13.2 17.3372 12.6628 16.8 12 16.8C11.3372 16.8 10.8 17.3372 10.8 18C10.8 18.6628 11.3372 19.2 12 19.2Z" fill="black"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M21.5243 11.4C21.2579 10.3649 20.3181 9.60004 19.2 9.60004C18.0818 9.60004 17.1419 10.3649 16.8756 11.4H0.599987C0.268589 11.4 0 11.6687 0 12C0 12.3313 0.268589 12.6 0.599987 12.6H16.8756C17.1421 13.6351 18.0818 14.3999 19.2 14.3999C20.3181 14.3999 21.258 13.6351 21.5243 12.6H23.3999C23.7312 12.6 23.9999 12.3313 23.9999 12C23.9999 11.6687 23.7312 11.4 23.3999 11.4H21.5243ZM19.2 13.2C19.8628 13.2 20.3999 12.6628 20.3999 12C20.3999 11.3372 19.8626 10.8 19.2 10.8C18.5372 10.8 18 11.3372 18 12C18 12.6628 18.5372 13.2 19.2 13.2Z" fill="black"/>
                    </g>
                    <defs>
                        <clipPath id="clip0_2535_11061"><rect width="24" height="24" fill="white"/></clipPath>
                    </defs>
                </svg>
            </span>
        </label>
    )
}

export default function Toolbar() {
    const { loading, query, response, pageType } = useAppStateSelector(state =>
        pick(state, "loading", "query", "response", "pageType")
    )

    const selectedFiltersCount = useSelectedFiltersCount()

    const docCount = response.products?.total ?? 0

    const totalSummary = pageType === "category" ? `${response?.products?.categoryPath}` : `'${query.query}' - ${docCount} results`


    return (
        <div
            class="ns-header-controls ns-d-flex ns-flex-column ns-flex-md-row ns-d-none ns-d-md-flex  ns-flex-wrap align-center ns-justify-content-between"
            style={loading ? "opacity: 0.3; justify-content: end !important;" : ""}
        >
            {!loading && (
                <h1
                    class="ns-d-inline ns-d-md-block ns-order-md-first ns-header-info"
                    data-nosto-element="totalResults"
                >
                    {totalSummary}
                </h1>
            )}
            <div class="ns-d-flex ns-flex-wrap ns-justify-content-between ns-d-md-block nos-w-100 ns-mb-4">
                <ToggleMobileSidebarButton
                    selectedFiltersCount={selectedFiltersCount}
                />
            </div>
        </div>
    )
}
